import { culture } from '../../utils/intl';

// https://bnp-ets-fra.local/api/turbomap/productDetails/FRBNPP016RL9
const API_URL_BASE = '/api/turbomap';
const HEADERS_JSON = {
	'Accept': 'application/json',
	'Content-Type': 'application/json',
};

const handleFetch = (url, fetchOptions = {}, returnJson = true) => fetch(url, fetchOptions)
	.then((res) => {
		if (res.ok) {
			return returnJson ? res.json() : true;
		}

		throw Error('Something went wrong wile fetching', res);
	});

const get = (filters = {}) => {
	// IE11 seems to cache the URL and response hard, adding cache busting to prevent this
	filters.cb = new Date().getTime();

	const urlParams = new URLSearchParams();

	for (const [key, value] of Object.entries(filters)) {
		if (value) {
			urlParams.append(key, value);
		}
	}

	const urlParamsString = urlParams.toString();

	return handleFetch(`${API_URL_BASE}/query/${culture}?${urlParamsString}`, { headers: HEADERS_JSON });
};

const getProductDetails = isin => handleFetch(`${API_URL_BASE}/productDetails/${isin}`, { headers: HEADERS_JSON });


export {
	get,
	getProductDetails,
};
